<template>
  <div class="banner-section" @click="$emit('click')">
    <div class="banner-section__left">
      <img
        class="banner-section__icon"
        src="@/assets/home/icn_invite_heart.png"
        alt="invite"
      />
      <div class="banner-section__text">
        <span class="typo-md-bold">솔닥 컨시어지 초대하기</span>
        <span class="typo-sm-medium">친구에게 솔닥을 알려주세요!</span>
      </div>
    </div>
    <img
      class="banner-section__arrow"
      src="@/assets/home/icn_arrow_right_gray.png"
      alt="arrow"
    />
  </div>
</template>

<script>
export default {
  name: 'BannerSection',
}
</script>

<style scoped>
.banner-section {
  display: flex;
  padding: 20px 16px;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  border-radius: 16px;
  background: #D8D9F0;
  margin: 0 16px;
  box-sizing: border-box;
  cursor: pointer;
}

.banner-section__left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.banner-section__icon {
  width: 50px;
  height: 50px;
  flex-shrink: 0;
}

.banner-section__text {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.banner-section__arrow {
  width: 22px;
  height: 22px;
  flex-shrink: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/new/organisms/BannerSection.vue